module.exports = __webpack_public_path__ + "img/button_04.3e537f91.png";